<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      size="small"
      fit
      row-key="Id"
    >
      <el-table-column prop="Id" width="70" fixed></el-table-column>
      <el-table-column label="帐号详细" width="80">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="openUserInfo(scope.row.UserId)"
            type="info"
            icon="el-icon-user-solid"
            circle
            :loading="openUserInfoLoading"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Phone" :label="$t('Phone')" width="150">
      </el-table-column>
      <el-table-column :label="$t('TypeName')" width="150">
        <template slot-scope="scope">
          {{ $t("Transaction.Type." + scope.row.Type) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('Amount')" width="120">
        <template slot-scope="scope">
          <span :class="scope.row.Amount > 0 ? 'text_red' : 'text_green'"
            >{{ scope.row.Amount > 0 ? "+" : "" }}{{ scope.row.Amount }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Remark')"
        prop="InternalRemark"
        width="300"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="ApiStatus" label="可派api" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.ApiStatus ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.ApiStatus ? "成功" : "失败" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="TransactionId" label="TransactionId" width="120">
      </el-table-column>
      <el-table-column label="操作人" width="120">
        <template slot-scope="scope">
          {{ scope.row.Admin == null ? "系统" : scope.row.Admin.NickName }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('DateTime')" prop="DateTime" width="130">
        <template slot-scope="scope">{{
          formatDateTime(scope.row.DateTime)
        }}</template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <!--用户详细-->
    <el-dialog
      title="用户详细"
      :visible.sync="UserInfoVisible"
      v-model="UserInfoVisible"
      :close-on-click-modal="false"
      size="small"
      width="30%"
    >
      <el-form :model="userInfo" size="small">
        <div class="headview">
          <img v-bind:src="userInfo.headurl" class="headimg" />
          <div class="data">
            <div>{{ userInfo.name }}</div>
            <div>手机号码 ：{{ userInfo.phone }}</div>
            <div>
              余额 ：<span class="text_red">{{ userInfo.credit }}</span>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="UserInfoVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!--新增界面-->
    <el-dialog
      title="消费储值"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <el-form-item
          label="选择可派帐号"
          prop="UserId"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + '可派帐号',
          }"
        >
          <SearchKoipyUser v-model="addForm.UserId"></SearchKoipyUser>
        </el-form-item>
        <el-form-item
          label="类型"
          prop="Type"
          :rules="{ required: true, message: $t('pleaseChoose') + '类型' }"
        >
          <el-select v-model="addForm.Type" placeholder="Select Type">
            <el-option
              v-for="(value, key) in $t('Transaction.Type')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('Amount')"
          prop="Amount"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Amount'),
          }"
        >
          <el-input-number
            v-model.number="addForm.Amount"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="内部备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            v-model="addForm.InternalRemark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  getUserTransactionList,
  updateUserAmount,
  getUserInfoById,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      openUserInfoLoading: false,
      UserInfoVisible: false,
      userInfo: {},
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
    };
  },
  methods: {
    openUserInfo(uid) {
      let para = {
        id: uid,
      };
      this.openUserInfoLoading = true;
      getUserInfoById(para).then((res) => {
        this.userInfo = res.data.response;
        this.UserInfoVisible = true;
        this.openUserInfoLoading = false;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
   
      let para = {
        key: this.filters.Name,
        page: this.page,
      };   
      this.listLoading = true;
      getUserTransactionList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //显示新增界面
    updateUserAmount() {
      this.addFormVisible = true;
      this.addForm = {
        Amount: 0,
        InternalRemark: "",
      };
    },
    //新增活动
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              updateUserAmount(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    this.getList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style scoped>
.headview {
  display: flex;
  align-items: center;
}
.headview img {
  margin-right: 20px;
}
.headview .data {
  height: 80px;
}
.headview .data div {
  line-height: 25px;
}
.headimg {
  width: 80px;
  height: 80px;
  border: 3px solid #f7a600;
  border-radius: 50%;
}
</style>
